import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Directive({
  selector: '[appDebounceInput]',
  standalone: true,
})
export class DebounceInputDirective implements OnInit {
  @Input() debounceMs = 300; // Default debounce time
  @Output() debounceInput = new EventEmitter<string>();

  private inputSubject = new Subject<string>();

  ngOnInit(): void {
    this.inputSubject.pipe(debounceTime(this.debounceMs)).subscribe(value => {
      this.debounceInput.emit(value);
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.inputSubject.next(input.value);
  }
}
